<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0" [formGroup]="resultForm">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class=" d-flex align-items-center pl-3">
                                        <img alt="Logo" src="../../assets/img/ExamMaster.png"
                                            class="mh-45px pb-2">
                                        <div class="ml-2">
                                            <h3 class="main-content-label mb-1"><b>
                                                {{title}}
                                                </b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                {{title}} - Details
                                            </p>
                                        </div>
                                    </div>
                                    <hr >
                                    <div class="row">
                                        <div class="col-md-8 ">
                                            <div class="cutom p-3 mb-3">
                                              <p class="main-content-title card-sub-title f20 mb-0"><b>{{title_one}} </b></p>
                                                <p class="main-content-title card-sub-title f20 mb-0"><b>{{title_two}} </b></p>
                                                <p class="main-content-title card-sub-title f20 mb-0"><b>{{title_three}}</b></p> 
                                            </div>
                                        </div>
                                        <div class="col-md-4 mt-5 pt-4" [formGroup]="resultSearchForm">
                                            <mat-form-field appearance="outline" class="example-full-width mt-4 " >
                                                <mat-label>Search Records</mat-label>
                                                <input class="color" matInput placeholder="Search Records" 
                                                    (keyup)="keypress()" formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                                <!-- <mat-hint>Hint</mat-hint> -->
                                            </mat-form-field>
                                        </div>
                                        
                                    </div>
                                    <hr >
                                    <div class="row clearfix">
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>Session</mat-label>
                                                        <mat-select #selectSession class="colorblack"
                                                                    formControlName="SessionId"
                                                                    (selectionChange)="onSessionChange($event.value)"
                                                                    required>
                                                            <mat-select-filter *ngIf="selectSession.focused"
                                                                               [placeholder]="'Filter'"
                                                                               [displayMember]="'SnName'"
                                                                               [array]="sessionList"
                                                                               (filteredReturn)="filteredSessionList = $event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredSessionList"
                                                                        [value]="item.SnNo">
                                                                {{ item.SnName }}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="resultForm.controls['SessionId'].touched && resultForm.controls['SessionId'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>Exam</mat-label>
                                                        <input formControlName="Exam" onkeydown="return (event.keyCode!=13);" class="color" matInput 
                                                            placeholder="Exam Name" required>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3" *ngIf="isBranch">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>Branch</mat-label>
                                                        <mat-select formControlName="branch" #select301 placeholder="Branch Available"
                                                            class="colorblack">
                                                            <mat-select-filter *ngIf="select301.focused"
                                                                [placeholder]="'Branch Available'"
                                                                [displayMember]="'DsName'" [array]="BranchDistrictList"
                                                                (filteredReturn)="filteredBranchDistrictList =$event">
                                                            </mat-select-filter>
                                                            <mat-option (click)="loadGraceValues({'StrId': item.SsShId,'ShId' : GLO_ShId})" *ngFor="let item of filteredBranchDistrictList"
                                                                [value]="item.SsShId">
                                                                {{item.DsName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3" *ngIf="isDistrict">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>District</mat-label>
                                                        <mat-select formControlName="district"  #select3 placeholder="District Available"
                                                            class="colorblack">
                                                            <mat-select-filter *ngIf="select3.focused"
                                                                [placeholder]="'District Available'"
                                                                [displayMember]="'StrName'" [array]="BranchDistrictList"
                                                                (filteredReturn)="filteredBranchDistrictList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredBranchDistrictList"
                                                                [value]="item.SsDsCode">
                                                                {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3" *ngIf="isGrace">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>Grace</mat-label>
                                                        <input formControlName="grace"  onkeydown="return (event.keyCode!=13);" class="color" matInput
                                                            placeholder="Grace">
                                                            <!-- <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['FcDesc'].touched && ResultForm.controls['FcDesc'].errors?.required">
                                                                This Field Is Mandatory.
                                                            </mat-error>
                                                            <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['FcDesc'].touched && ResultForm.controls['FcDesc'].errors?.pattern">
                                                            Please Enter Valid Data
                                                        </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3" *ngIf="isGraceClass">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>Class Grace</mat-label>
                                                        <input formControlName="classGrace"  onkeydown="return (event.keyCode!=13);" class="color" matInput
                                                            placeholder="lass Grace">
                                                            <!-- <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['FcDesc'].touched && ResultForm.controls['FcDesc'].errors?.required">
                                                                This Field Is Mandatory.
                                                            </mat-error>
                                                            <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['FcDesc'].touched && ResultForm.controls['FcDesc'].errors?.pattern">
                                                            Please Enter Valid Data
                                                        </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3" *ngIf="rollNo">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>Roll No</mat-label>
                                                        <input formControlName="RollNo"  onkeydown="return (event.keyCode!=13);" class="color" matInput
                                                            placeholder="RollNo">
                                                            <!-- <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['FcDesc'].touched && ResultForm.controls['FcDesc'].errors?.required">
                                                                This Field Is Mandatory.
                                                            </mat-error>
                                                            <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['FcDesc'].touched && ResultForm.controls['FcDesc'].errors?.pattern">
                                                            Please Enter Valid Data
                                                        </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3" *ngIf="isGraceMaxPaper">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>Max Grace Papers</mat-label>
                                                        <input formControlName="maxClassGrace"  onkeydown="return (event.keyCode!=13);" class="color" matInput
                                                            placeholder="Max Grace Papers">
                                                            <!-- <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['FcDesc'].touched && ResultForm.controls['FcDesc'].errors?.required">
                                                                This Field Is Mandatory.
                                                            </mat-error>
                                                            <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['FcDesc'].touched && ResultForm.controls['FcDesc'].errors?.pattern">
                                                            Please Enter Valid Data
                                                        </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        
                                            <div class="col-sm-12 row">
                                                <div class="col-sm-12 prpl">
                                                    <button type="button"*ngIf="submitButton"
                                                        class="btn sz1 btn-primary btn-icon-text floatright mt-1 fr">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/exit.gif" style="margin-right: 5px;">
                                                             Exit
                                                        </span>
                                                        </button>
    
                                                        <button type="button" *ngIf="submitButton"
                                                        class="btn sz btn-primary btn-icon-text floatright mr-3 mt-1 fr"
                                                        (click)="ValidateAndProcess()">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/list.gif" style="margin-right: 7px;">
                                                             Process
                                                        </span>
                                                        </button>
                                                </div>
                                            </div>
                                        
                                        <!-- <div class="col-sm-12">
                                            <button type="button"
                                                class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                *ngIf="submitButton">Exit</button>
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                                *ngIf="submitButton" (click)="ValidateAndProcess()">Process</button>
                                                
                                           
                                        </div> -->

                                       
                                    </div>
                                   
                                        <hr>
                                   
                                    <div class="table-responsive table-container">
                                        <table id="datatable"
                                            class="table table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th width="15%" class="f600">
                                                       Id
                                                    </th>
                                                    <th width="15%" class="f600">
                                                        Exam
                                                    </th>
                                                    <th width="50%"  class="f600">
                                                        Name
                                                    </th>
                                                    <th width="10%" class="f600">
                                                        Count
                                                    </th>
                                                    <th width="10%" class="f600">
                                                        Open List
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data" *ngIf="resultList.length > 0">
                                                <tr *ngFor="let result of resultList;" (click)="loadBranchList(result,MenuCode)">
                                                    <!-- (click)="loadBranchList(result,MenuCode)" -->
                                                    <td> {{result.ShId}} </td>
                                                    <td class="an">{{result.EmCode}} </td>
                                                    <td> {{result.EmName}} </td>
                                                    <td>{{result.Cnt}} </td>
                                                    <td>{{result.OpenLists}} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                                    (page)="onPageChange($event)"></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>